import { createFileRoute } from '@tanstack/react-router';
import Velocity from '../../../components/Graphs/Velocity';

export const Route = createFileRoute('/_authenticated/graphs/velocity/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'graph.velocity.page.title',
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: VelocityGraphRoute,
});

function VelocityGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <Velocity vehicleId={Number(vehicleId)} isPage />;
}
